<template>
    <v-select
        v-model="versions"
        :label="$t('VersionSelector.label')"
        :items="selectableReleases"
        item-text="versions.st"
        item-value="versions"
        filled
        color="primary"
        :dense="dense"
        hide-details="auto"
        @change="deselectFeatureCheck"
        :disabled="disabled || !hardwareSelected"
        :placeholder="hardwareSelected ? $t('VersionSelector.placeholder') : $t('VersionSelector.placeholder_needs_device')"
    >
        <template v-slot:append-outer v-if="!hideInfo">
            <v-icon 
                @click="openReleasesUrl"
                class="mt-4"
            >
                mdi-information-outline
            </v-icon>
        </template>
        <template v-slot:append>
            <v-icon>{{ disabled || !hardwareSelected ? "" : "mdi-chevron-down" }}</v-icon>
        </template>
        <template v-slot:item="item">
            <h5>
                <b>{{ `ST: ${item.item.versions.st}` }}</b>  
                {{ `&nbsp;NRF: ${item.item.versions.nrf} ESP: ${item.item.versions.esp}`}}
            </h5>
            <h6> {{ `&nbsp;&nbsp;&nbsp;${item.item.label}` }} </h6>
        </template>
    </v-select>
</template>

<script>
import { cloneDeep } from 'lodash'
import stMinVersionMet from '../utils/stMinVersionMet'
export default {
    props: {
        hideInfo: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        local: {
            type: Boolean,
            default: false
        },
        value: {
            default: null
        },
        hardwareVersion: {
            default: undefined
        }
    },
    computed: {
        versions: {
            get() {
                return this.local ? this.value : this.$store.getters.versions
            },
            set(value) {
                if (this.local) {
                    this.$emit('input', value)
                    return
                }
                this.$store.dispatch('setVersions', value)
            }
        },
        releases() {
            return this.$store.getters.releases
        },
        hardwareSelected() {
            if (this.local) {
                return this.hardwareVersion != null
            }
            return this.$store.getters.selectedHardwareVersion != null
        },
        selectableReleases() {
            let selectableReleases = cloneDeep(this.releases) || []
            if(!this.isAdmin) {
                selectableReleases = selectableReleases.filter(release => !release.adminOnly)
            }
            if(this.templateMinVersion) {
                selectableReleases = selectableReleases.filter(release => stMinVersionMet(release.versions.st, this.templateMinVersion.st))
            }
            return selectableReleases
        },
        isAdmin() {
            return this.$store.getters.isAdmin
        },
        templateMinVersion() {
            return this.$store.getters.template?.min_version
        }
    },
    methods: {
        openReleasesUrl() {
            window.open('https://docs.iotracker.eu/release_notes/iot3/#releases', '_blank')
        },
        deselectFeatureCheck() {
            if (this.local) {
                return
            }
            let selected = this.$store.getters.selected
            if(selected) {
                // TODO: deselect selected feature if not within min/max versions
            }
        }
    },
    watch: {
        templateMinVersion(versions) {
            if (this.local) {
                return
            }
            if(versions && this.hardwareSelected && this.selectableReleases.length) {
                this.versions = this.selectableReleases[0].versions
            }
        }
    }
}
</script>
